import React from 'react';
import { Form, Typography } from 'antd';
import { connect } from 'react-redux';

function _Department(props) {
  return (
    <Form.Item label="部门">
      <Typography.Paragraph className="organizationName" ellipsis={{ rows: 2 }}>
        {props.organizationName}
      </Typography.Paragraph>
    </Form.Item>
  );
}

function mapStateToProps(state) {
  try {
    return {
      organizationName: state.userInfo.userMap.organizationName,
    };
  } catch (ex) {
    return {
      organizationName: '-',
    };
  }
}

export default connect(mapStateToProps)(_Department);
